<template>
    <div class="w-100 d-flex flex-column justify-content-between">
        <HeaderBar/>
        <div class="px-1 ">
            <div class="d-flex flex-column  mt-4 ">
                <div class="title d-flex justify-content-center align-items-center mt-2">
                    Editar Finca
                </div> 
            </div>
            <div>
                <validation-observer ref="GanForm">
                    <b-form class="auth-register-form " @submit.prevent="">
                        <b-form-group label="Nombre" label-for="name" class="name">
                            <validation-provider #default="{ errors }" name="Nombre" rules="required">
                                <b-form-input id="name" v-model="farm.name"
                                    :state="errors.length > 0 ? false : null" name="name" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label="Área Total en HA" label-for="total" >
                            <validation-provider #default="{ errors }" name="Area Total" rules="required">
                                <b-form-input id="total" v-model="farm.total_ha"
                                    :state="errors.length > 0 ? false : null" name="veterinarian" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <div class="d-flex">
                            <b-form-group label="Area de Pastos" label-for="pastureArea" class="pt-0 mt-0" >
                            <validation-provider #default="{ errors }" name="Area de pastos" rules="required">
                                <b-form-input id="pastureArea" v-model="farm.pasture_ha"
                                    :state="errors.length > 0 ? false : null" name="pastureArea" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            </b-form-group>
                            <b-form-group label="# de Apartos" label-for="device" class="pt-0 mt-0">
                                <validation-provider #default="{ errors }" name="Apartos" rules="required">
                                    <b-form-input id="device" v-model="farm.aparts_ha"
                                        :state="errors.length > 0 ? false : null" name="device" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Area Bosque" label-for="forest" class="pt-0 mt-0">
                                <validation-provider #default="{ errors }" name="Area de bosque" rules="required">
                                    <b-form-input id="forest" v-model="farm.forest_ha"
                                        :state="errors.length > 0 ? false : null" name="veterinarian" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group> 
                        </div>
                        <b-form-group label="CVO" label-for="CVO">
                            <validation-provider 
                            #default="{ errors }" 
                            name="CVO" 
                            :rules="{required:true, regex:'^[1-7]{1}[0-9]{8}$'}">
                                <b-form-input id="CVO" v-model="farm.cvo"  type="number"
                                    :state="errors.length > 0 ? false : null" name="veterinarian" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>   
                        <b-form-group label="Sistema Productivo" label-for="productSystem" class=" w-100 mr-1">
                            <b-form-select id="productSystem" v-model="farm.system_id" :options="productSystemOptions" :value="productSystemOptions.value" label="text" />
                        </b-form-group>
                        <b-form-group label="Provincia" label-for="batch" class="w-100">
                            <b-form-select id="batch" v-model="farm.province_id" :options="provincesOptions" :value="provincesOptions.value" label="text" />
                        </b-form-group>
                        <b-form-group label="Cantón" label-for="canton ">
                            <b-form-select id="canton" v-model="farm.canton_id" :options="cantonOptions"  :value="cantonOptions.value"  label="text" />
                        </b-form-group>
                        <b-form-group label="Distrito" label-for="district">
                            <b-form-select id="district" v-model="farm.district_id" :options="districtOptions" :value="districtOptions.value" label="text" />
                        </b-form-group>
                        <div class="d-flex justify-content-center pb-5 ">
                            <b-button type="submit" v-on:click="insertFarm"
                                class="bg-primary dataButton  d-flex align-items-center justify-content-center w-75 ">
                                <div class="ml-1"> Guardar Finca </div>
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer>
            </div>
            <ControlMenu />
        </div>
    </div>
</template>



<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from 'vue-select'
import axios from 'axios'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormTextarea,BFormSelect, BFormGroup, BFormInput, BForm, BImg, BButton, BFormCheckbox } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        ControlMenu,
        HeaderBar,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BForm,
        required,
        vSelect,
        BImg,
        BButton,
        BFormCheckbox,
        BFormTextarea,
    },
    data() {
        return {
            date: null,
            dateDefault: null,
            timePicker: null,
            datetime: null,
            multiDate: null,
            rangeDate: null,    
            humanDate: null,
            disableDate: null,
            inlineDate: null,
            veterinarian: '',
            femaleAnimal: null,
            totalLitter: '',
            productSystemOptions:[],
            cvoOptions:[],
            
            batch: '',
            canton: '',
            cantonOptions:[],
            animal: '',
            ageOptions: [],
            batchOptions: [],
            provincesOptions:[],
            animalOptions: [],
            districtOptions:[],
            farm:{
                name: '',
                total_ha:'',
                forest_ha:'',
                aparts_ha:'',
                pasture_ha:'',
                cvo:'',
                system_id:'',
                province_id:'',
                canton_id:'',
                district_id:'',
                user_id:localStorage.getItem('userID')
            }
        }
    },
    methods: {
        async fetchProductSystem(config){
            
            fetch(this.$apiUrl+"list/systems", config)
            .then(response => response.json())
            .then(result => {
                this.productSystemOptions = result.systems.map(item => {return {value:item.id,text:item.name}})
            })
        },
        
        async fetchFarm(config){
            fetch(this.$apiUrl+"view/farms/"+this.$route.params.id, config)
            .then(response => response.json())
            .then(result => {
                this.farm = result.farms;
            }) 
        },
        
        async fetchProvinces(config){
          
          fetch(this.$apiUrl+"list/provinces", config)
          .then(response => response.json())
          .then(result => {
              console.log(result.provinces);
              this.provincesOptions = result.provinces.map(item => {return {value:item.id,text:item.name}})
          })
        },

        async fetchCantons(config){
          
            fetch(this.$apiUrl+"list/cantons", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.cantons);
                this.cantonOptions = result.cantons.map(item => {return {value:item.id,text:item.name}})
            })
        },
        async fetchDistricts(config){
            fetch(this.$apiUrl+"list/districts", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.districts);
                this.districtOptions = result.districts.map(item => {return {value:item.id,text:item.name}})
            })
        },

        insertFarm(){
            this.$refs.GanForm.validate().then(success => {
                if(success){
                    let pasture = parseFloat(this.farm.pasture_ha);
                    let forest = parseFloat(this.farm.forest_ha);
                    if(parseFloat(forest+pasture)>parseFloat(this.farm.total_ha)){
                        this.$swal({
                                title: 'Registro de finca',
                                text: 'El área total no debe ser menor al area de pastos y bosques.',
                                type: 'warning',
                                icon:'warning',
                                showCancelButton: false,
                                confirmButtonColor:'#5E8F23',
                                showCloseButton: true,
                                showLoaderOnConfirm: false  
                            });
                    }else{
                        let self=this;
                        const token = localStorage.getItem("accessToken");
                        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                        this.$http.post("edit/farms/"+this.$route.params.id, this.farm,config).then(() => {
                            this.farm={
                                name: '',
                                total_ha:'',
                                forest_ha:'',
                                aparts_ha:'',
                                pasture_ha:'',
                                cvo:'',
                                system_id:'',
                                province_id:'',
                                canton_id:'',
                                district_id:'',
                                user_id:localStorage.getItem('userID')
                            }
                        
                            this.$swal({
                                title: 'Registro de finca',
                                text: 'Se insertó finca de manera satisfactoria',
                                type: 'success',
                                icon:'success',
                                showCancelButton: false,
                                confirmButtonColor:'#5E8F23',
                                showCloseButton: true,
                                showLoaderOnConfirm: false  
                            }).then(function(){
                                history.back();
                            });
                        }).catch(error => {
                            console.log(error)
                        });
                    }                   
                }
            })    
        },
    },
    watch:{
        'farm.province_id': function(value){
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            console.log(value);
            fetch(this.$apiUrl+"list/cantons?province_id="+value,config)
            .then(response => response.json())
            .then(result => {
                console.log(result.cantons);
                this.cantonOptions = result.cantons.map(item => {return {value:item.id,text:item.name}})
            })

        },
        'farm.canton_id':function(value){
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            console.log(value);
            fetch(this.$apiUrl+"list/districts?canton_id="+value,config)
            .then(response => response.json())
            .then(result => {
                console.log(result.districts);
                this.districtOptions = result.districts.map(item => {return {value:item.id,text:item.name}})
            })
        },
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchFarm(config);
        this.fetchProductSystem(config);
        this.fetchProvinces(config);
        this.fetchCantons(config);
        this.fetchDistricts(config);
    }
}
</script>
    

<style lang="scss">
.dataUploadTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    color: #5E5873;
}



@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>